import React, { useContext, useState } from 'react'
import { MdCancel, MdOutlineDeleteOutline } from 'react-icons/md';
import { MdBlockFlipped } from "react-icons/md";
import { MdModeEditOutline } from "react-icons/md";
import { BasePopupContext } from '../../hooks/usePopup';
// import FormContainer from './Add/Container';
import { CATEGORIES, CONTENT_TYPE, DATE_FORMAT_DISPLAY, INSTAGRAM, POPUP_SMALL } from '../../constants';
import { RxInstagramLogo } from "react-icons/rx";
import { MdPhone } from "react-icons/md";
import { DateTime } from 'luxon';
import { HiCalendarDateRange } from "react-icons/hi2";
import { Link, useNavigate } from 'react-router-dom';
import { PiTiktokLogo } from 'react-icons/pi';
import FormattedCurrency from '../../components/FormattedCurrency';
import { HiOutlineSparkles } from 'react-icons/hi';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { set_active_profile } from '../../redux/slices/influencerProfileSlice';
import { setAgencyInfluencerProfile } from '../../utils';
import { set_chat_to_load } from '../../redux/slices/chatsSlice';

const Card = ({ item, refreshListing, data, agencyInfluencerProfile, sessionId }) => {

    const { setPopup } = useContext(BasePopupContext);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [showAllNiches, setShowAllNiches] = useState(false);

    const handleChangeProfile = () => {
        dispatch(set_active_profile(agencyInfluencerProfile))
        setAgencyInfluencerProfile(agencyInfluencerProfile)
        navigate("/deliverable/" + item.id)

    }

    const handleClickEditCategory = () => {
        // setPopup({
        //     heading: "Edit Category",
        //     component: <FormContainer isUpdate={true}/>,
        //     size: POPUP_SMALL,
        //     contained: true

        // })
    }

    return (
        <div
            onClick={(e) => {
                e.stopPropagation()
                if (agencyInfluencerProfile) {
                    handleChangeProfile()
                } else {
                    navigate("/deliverable/" + item.id)
                }
            }}
            className='bg-white py-6 relative  px-6 lg:px-4 rounded-2xl hover:scale-[1.04] hover:transition-all hover:cursor-pointer duration-75 shadow-md  border-[1px] w-full min-h-[200px]'>
            <div
                onClick={(e) => {
                    e.stopPropagation()
                    // dispatch(set_chat_to_load(item.id))
                    // dispatch(set_chat_to_load(1))

                    navigate("/chats/" + sessionId)
                }}
                className='absolute top-4 right-6 hover:-translate-y-1 transition-all duration-300 mx-auto w-10 h-10 min-h-10 min-w-10  rounded-full bg-primary flex items-center justify-center mb-4'>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                    />
                </svg>
            </div>
            <div className='flex items-center gap-x-3 flex-grow'>
                <div
                    className={`flex items-center justify-center w-12 h-12 min-w-12 min-h-12 rounded-xl bg-[#FAFAFA] bg-cover bg-center bg-no-repeat`}
                    style={{
                        backgroundImage: `url(${data?.campaign?.agency?.user?.picture})`
                    }}
                >
                    {
                        !data.campaign.agency.user.picture &&
                        <HiOutlineSparkles className='text-3xl text-primary' />
                    }
                </div>
                <div className='flex flex-col gap-y-'>
                    <h1 className='text-2xl font-bold break-all w-[80%] md:w-[90%] text-t-dark'> {data.campaign?.agency?.company_name}</h1>
                    <p className='text-xs inline-flex space-x-3 items-center text-gray-500'>
                        <span className='inline-flex space-x-2'>
                            <MdPhone className='text-base' />
                            <span>{data.campaign?.agency?.contact_number}</span>
                        </span>
                        <span className='text-base'>•</span>
                        <span className='inline-flex space-x-2'>
                            <HiCalendarDateRange className='text-base' />
                            <span>{DateTime.fromISO(item?.release_dates[0]?.release_date).toFormat(DATE_FORMAT_DISPLAY)}</span>
                        </span>
                    </p>
                    {/* <p className='text-xs text-gray-500'>Barcelona, ESP</p> */}
                </div>
            </div>
            <div className='flex flex-wrap gap-2 my-5'>
                {/* {
                    item.target_niche.map((niche, index) => (
                        <div key={index} className={`text-xs rounded-xl px-3 py-0.5 bg-[#FFEFEE] text-[#C57572]`}>
                            {CATEGORIES.find((item) => item.value === niche)?.label ? CATEGORIES.find((item) => item.value === niche)?.label : niche}
                        </div>
                    ))
                } */}
                {
                    !showAllNiches && item?.target_niche?.slice(0, 2).map((niche, index) => (
                        <div key={index} className={`text-xs rounded-xl px-3 py-0.5 bg-[#FFEFEE] text-[#C57572]`}>
                            {CATEGORIES.find((category) => category.value === niche)?.label ? CATEGORIES.find((category) => category.value === niche)?.label : niche}
                        </div>
                    ))
                }
                {
                    showAllNiches && item?.target_niche.map((niche, index) => (
                        <div key={index} className={`text-xs rounded-xl px-3 py-0.5 bg-[#FFEFEE] text-[#C57572]`}>
                            {CATEGORIES.find((category) => category.value === niche)?.label ? CATEGORIES.find((category) => category.value === niche)?.label : niche}
                        </div>
                    ))
                }
                {
                    showAllNiches && item?.target_niche?.length > 2 && (
                        <span onClick={(e) => { e.stopPropagation(); setShowAllNiches(false) }} className="text-xs cursor-pointer rounded-xl  px-3 py-0.5 bg-secondary text-white">
                            <FormattedMessage id="show_less" defaultMessage={"Show less"} />
                        </span>
                    )
                }
                {!showAllNiches && item?.target_niche?.length > 2 && (
                    <span onClick={(e) => { e.stopPropagation(); setShowAllNiches(true) }} className="text-xs cursor-pointer rounded-xl px-3 py-0.5 bg-[#FFEFEE] text-[#C57572]">
                        +{item?.target_niche?.length - 2}
                    </span>
                )}
                {/* <div className={`text-xs rounded-xl px-3 py-0.5 bg-[#F8E8F7] text-[#C27EBF]`}>
                        Fashion
                    </div> */}

            </div>
            <div style={{ overflowWrap: "anywhere" }} className='my-5 text-sm !line-clamp-2'>
                {data.campaign?.project_description}
            </div>
            <div className='flex flex-col sm:flex-row  gap-x-2 mt-5 space-y-4 sm:space-y-0'>
                <div className='p-2 w-full  min-h-10 rounded-xl'>
                    <div className='text-xs text-[#A3A3A3]'><FormattedMessage id='finalize_budget' defaultMessage="Finalize Budget" /></div>
                    <div className='text-base'><FormattedCurrency value={item.finalized_budget} /></div>
                </div>
                <div className='p-2 w-full  min-h-10 rounded-xl'>
                    <div className='text-xs text-[#A3A3A3]'>Quantity</div>
                    <div className='text-base'>{item.quantity}</div>
                </div>
                <div className='p-2 w-full  min-h-10 rounded-xl'>
                    <div className='text-xs text-[#A3A3A3] capitalize'><FormattedMessage id='content' defaultMessage="Content" /></div>
                    <div className=' inline-flex space-x-1 items-center text-sm'>
                        {/* {CONTENT_TYPE.find((type) => type.value === item.content_type)?.platform === INSTAGRAM ? <RxInstagramLogo className='text-2xl' /> : <PiTiktokLogo className='text-2xl'/>}  */}
                        <span className=' capitalize'>{CONTENT_TYPE.find((type) => type.value === item.content_type)?.label}</span></div>
                </div>

            </div>

        </div>
    )
}

export default Card;
